// İlk girişte (oturum başına bir kez) KVKK yükleme penceresi; kapatılabilir
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { ShieldAlert } from 'lucide-react';
import { StoreKvkkCard } from './StoreKvkkCard';
import { API } from './storeShared';

export const useStoreQuota = (enabled) => {
  const [quota, setQuota] = useState(null);
  const load = () => axios.get(`${API}/firm/store-quota`).then(r => setQuota(r.data)).catch(() => setQuota({ is_store: false }));
  useEffect(() => { if (enabled) load(); }, [enabled]);
  return [quota, load];
};

export const QuotaText = ({ quota }) => (
  <span data-testid="store-quota-text">KVKK Taahhütnamesi ve Aydınlatma Yükümlülüğü belgeleriniz onaylanana kadar en fazla <b>{quota.limit}</b> talep gönderebilirsiniz. Kalan talep hakkınız: <b className={quota.remaining ? 'text-amber-700' : 'text-rose-700'}>{quota.remaining} / {quota.limit}</b></span>
);

export const StoreFirstLoginPrompt = ({ userId }) => {
  const [quota, load] = useStoreQuota(true);
  const key = `store-kvkk-prompt-${userId}`;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (quota?.is_store && ['yok', 'eksik'].includes(quota.kvkk_state) && !sessionStorage.getItem(key)) setOpen(true);
  }, [quota, key]);
  const close = () => { sessionStorage.setItem(key, '1'); setOpen(false); };
  if (!quota?.is_store) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-lg" data-testid="store-kvkk-prompt">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-amber-600" />KVKK Belgeleri</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600"><QuotaText quota={quota} /></p>
        <StoreKvkkCard quota={quota} onUploaded={load} />
        <div className="flex justify-end"><Button variant="ghost" onClick={close} data-testid="store-kvkk-prompt-later">Daha sonra yükleyeceğim</Button></div>
      </DialogContent>
    </Dialog>
  );
};
